import GoodsLibrary from './root.vue'
import MainNav from './main_nav.vue'
import goodsList from './goods_list/router'
import goodsDetail from './goods_detail/router'
import goodsImport from './goods_import/router'
import goodsImportOperateDetail from './goods_import_operate_detail/router'

const route = {
    path: 'goodsLibrary',
    component: GoodsLibrary,
    children: [{
        path: '',
        redirect: 'nav'
    }, {
        path: 'nav',
        component: MainNav,
        children: [{
            path: '',
            redirect: goodsList.path
        },
            goodsList
        ]
    },
        goodsDetail,
        goodsImport,
        goodsImportOperateDetail
    ]
}

export default route
